import { A } from '@adornis/base/env-info.js';
import type { Maybe, ValueEvent } from '@adornis/base/utilTypes.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { css } from '@adornis/chemistry/directives/css.js';
import type { CampusExercise } from '@chancenwerk/campus-learning-content/entities/CampusExercise.js';
import '@chancenwerk/components/chancen-component-card-title.js';
import { ExerciseType } from '@chancenwerk/db/enums/enums.js';
import { html, nothing } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { CampusComponentExerciseEdit } from './campus-page-exercise-edit.js';

/**
 * @customElement campus-page-exercise-edit-geogebra
 */
@customElement('campus-page-exercise-edit-geogebra')
export class CampusPageExerciseEditGeogebra extends CampusComponentExerciseEdit {
  static override exerciseType: number = ExerciseType.GEOGEBRA;
  static override exerciseName: string = 'GEOGEBRA';
  static override exerciseElement: string = 'campus-page-exercise-edit-geogebra';

  @state() private readonly _geogebraInput = new RXController<Maybe<string>>(this, null);

  protected override getExcersiseType(): number {
    return CampusPageExerciseEditGeogebra.exerciseType;
  }

  protected override getExcersieName(): string {
    return CampusPageExerciseEditGeogebra.exerciseName;
  }

  constructor() {
    super();
  }

  override content() {
    return html`
      ${this.errorMsg.value ? html`<cr-text ${css({ color: 'red' })}>${this.errorMsg.value}</cr-text>` : nothing}
      <cr-card space="md" padding="md">
        <cr-flex horizontal space="md">
          <cr-flex flex space="md">
            <cr-flex space="md" space-between>
              <cr-text>Felder mit einem * müssen ausgefüllt werden!</cr-text>
              <cr-input ${this.form.field('title')} placeholder="Titel *"></cr-input>
              <cr-input
                .value=${this._geogebraInput.value ?? this.form.document?.geogebraContent.geogebraID}
                placeholder="Geogebra Aufgaben-ID *"
                @value-picked=${(e: ValueEvent<string>) => {
                  this._geogebraInput.next(e.detail.value);
                }}
              ></cr-input>
            </cr-flex>
          </cr-flex>
        </cr-flex>
      </cr-card>
    `;
  }

  protected override async handleFormSuccess(exercise: CampusExercise): Promise<void> {
    let geoId = this._geogebraInput.value ?? this.form.document?.geogebraContent.geogebraID;
    if (!this._geogebraInput.value && !this.form.document?.geogebraContent.geogebraID)
      return this.errorMsg.next('Bitte eine Geogebra-ID eingeben!');
    else if (!geoId && this._geogebraInput.value) geoId = this.extractId(this._geogebraInput.value);

    if (!geoId) return this.errorMsg.next('Die GeogebraID ist ungültig!');
    exercise.geogebraContent.geogebraID = geoId;
    const result = await fetch(`${A.absoluteUrl()}api/geogebra/${exercise.geogebraContent.geogebraID}`)
      .then(res => res.json())
      .catch(e => {
        console.error('error', e);
      });
    if (!result || result.error) return this.errorMsg.next('Die GeogebraID ist ungültig!');

    exercise.geogebraContent.width = result.width.toString();
    exercise.geogebraContent.height = result.height.toString();

    return super.handleFormSuccess(exercise);
  }

  private extractId(input: string): string | undefined {
    const regex = /(?:https?:\/\/)?(?:www\.)?geogebra\.org\/(?:m\/)?([a-z0-9]+)/i;
    const match = input.match(regex);

    if (match) {
      return match[1];
    } else {
      return input;
    }
  }
}
